
<div class="title has-text-centered">What type of charity<br/>are you?</div>

<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onEnglandAndWales}
    >Registered with Charity Commission for England &amp; Wales</button
  >
</div>
<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onScotland}
    >Registered with Scottish Charity Regulator</button
  >
</div>
<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onNorthernIrelan}
    >Registered with Charity Commission for Northern Ireland</button
  >
</div>
<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onCIC}
    >Community Interest Company (CIC)</button
  >
</div>
<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onCBS}
    >Community Benefit Society (CBS)</button
  >
</div>
<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onHMRC}
    >HMRC charity tax status</button
  >
</div>
<div class="block has-text-centered">
  <button class="button is-fullwidth is-outlined" style="white-space:pre-wrap;height:fit-content;" on:click={onUnregistered}
    >Another type of organisation</button
  >
</div>

<script lang="ts">

  import { goto } from "@sveltech/routify";

  function onEnglandAndWales() {
    $goto("/start/charity/types/engwalesregistered");
  }

  function onScotland() {
    $goto("/start/charity/types/scotlandregistered");
  }

  function onNorthernIrelan() {
    $goto("/start/charity/types/northernireland");
  }

  function onCIC() {
    $goto("/start/charity/types/cic");
  }

  function onCBS() {
    $goto("/start/charity/types/cbs");
  }

  function onHMRC() {
    $goto("/start/charity/types/hmrc");
  }

  function onUnregistered() {
    $goto("/start/charity/types/unregistered");
  }

</script>
